import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../SectionHeading';

const SignalSection = () => (
  <section className="py-24 bg-brand-surface border-t border-white/5 relative overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_right,_var(--tw-gradient-stops))] from-blue-900/20 via-transparent to-transparent"></div>
    <div className="max-w-5xl mx-auto px-6 lg:px-8 relative z-10">
      <SectionHeading title="The Signal & The Threshold" subtitle="Act III" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <h3 className="text-white font-display font-bold text-2xl mb-4">Project Odyssey</h3>
          <p className="text-gray-400 leading-relaxed mb-6">
            In its breathtaking final act, the chronicle arrives at Project Odyssey — humanity's first crewed interstellar mission, launching from Triton Station in <span className="text-brand-accent font-semibold">2514</span> toward Alpha Centauri, 4.37 light-years away.
          </p>
          <p className="text-gray-400 leading-relaxed">
            The 120-person crew crosses the heliopause as <span className="text-white">eight billion people across eight worlds</span> simultaneously dim their lights in the Vigil of Lights — pulsing like a single breathing body spread across four billion kilometers.
          </p>
        </motion.div>
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.15 }}>
          <h3 className="text-white font-display font-bold text-2xl mb-4">The Signal</h3>
          <p className="text-gray-400 leading-relaxed mb-6">
            In the outer reaches of the heliosphere, Neptune's sentinels detect a signal — <span className="text-white">recursive, self-referencing, with the information density of a mind</span> — arriving from a direction no known stellar source can explain, possibly traveling for millions of years.
          </p>
          <div className="bg-brand-dark border border-blue-500/20 rounded-xl p-5">
            <p className="text-gray-300 italic text-sm leading-relaxed">
              "We answer because we were spoken to. We answer because not answering would be the first time our civilization chose silence in response to another mind's voice — and we are better than that."
            </p>
            <p className="text-gray-600 text-xs mt-3">— The philosopher aboard the Odyssey</p>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);

export default SignalSection;